export default __webpack_public_path__ + "static/media/Abyssal Cloak of the Death Master.1fe14516.jpg";